import type { ClientCorporationMissionRecord, ClientMissionRecord, ClientMissionRewards } from '@game/shared-types';

export interface MissionState {
  missionRewards?: ClientMissionRewards;
  viewingMissionRecord?: ClientMissionRecord;
  viewingCorporationMissionRecord?: ClientCorporationMissionRecord;
}

export const missionDefault: MissionState = {};
